module.exports = __webpack_public_path__ + "static/media/login-background1080.d999a263.jpg";